import { cfgToThemeCdnPath } from '@infinitro/config';
const fomoAssets = {
    background: cfgToThemeCdnPath(`/about-vip/vip-background.png`),
    coins: '',
    coin: '',
    card1: cfgToThemeCdnPath(`/about-vip/card1.png`),
    card2: cfgToThemeCdnPath(`/about-vip/card2.png`),
    card3: cfgToThemeCdnPath(`/about-vip/card3.png`),
    card4: cfgToThemeCdnPath(`/about-vip/card4.png`),
    card5: cfgToThemeCdnPath(`/about-vip/card5.png`),
    step1: cfgToThemeCdnPath(`/about-vip/step1-new.png`),
    step2: cfgToThemeCdnPath(`/about-vip/step2-new.png`),
    step3: cfgToThemeCdnPath(`/about-vip/step3-new.png`),
    chests: '',
    cardsLeft: '',
    cardsRight: '',
    rocketPlanet: '',
    crown: '',
    banner: cfgToThemeCdnPath(`/about-vip/banner-background.png`),
    modalHeader: ''
};
export default fomoAssets;
